import React from 'react'
import { Box, Button, Flex } from '@workwhile/ui'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { RulesSearch } from './RulesSearch'
import { RulesTable } from './RulesTable'
import { useRulesContextValue } from '../context/RulesProvider'
import { useRulesWorkflowsContextValue } from '../context/RulesWorkflowsProvider'

const RulesHeader = () => {
  const { state, actions } = useRulesContextValue()
  const { createRuleFlow } = useRulesWorkflowsContextValue()

  return (
    <Header
      title="Rules"
      rightContent={
        <Flex alignItems="center" gap={2}>
          <QueryStatus
            dataUpdatedAt={state.dataUpdatedAt}
            isFetching={state.isFetching}
            refetch={actions.refetch}
            isError={state.isError}
            error={state.error}
          />
          <Button variant="primary" onClick={createRuleFlow.open}>
            Create Rule
          </Button>
        </Flex>
      }
    />
  )
}

export const RulesMain = () => {
  return (
    <>
      <RulesHeader />
      <Box margin={3}>
        <RulesSearch />
        <RulesTable />
      </Box>
    </>
  )
}
